<template>
    <div class="cB">
        <div class="outer">
            <div class="main" v-for="(item, index) in defaultdata" :key="index">
                <div class="m-item ">
                    <p class="title">{{ item.value1 }}</p>
                    <span class="num">{{ item.value2 }}</span>
                    <span class="unit">{{ item.value3 }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'template.scope8',
    data() {
        return {
            defaultdata: [
                { value1: "农村常住居民人均可支配收入", value2: '7893', value3: "元" },
                { value1: "低收入农户人均可支配收入", value2: '3561', value3: "元" },
            ],
            valueMap: [
                { name: '名称', key: "value1" },
                { name: '数值', key: "value2" },
                { name: '单位', key: "value3" },
            ]
        }
    },
    mounted() {

    },
    watch: {
    },
    methods: {

    },
    beforeDestroy() {

    },
}
</script>

<style scoped lang="scss">
@font-face {
    font-family: "YeJinShuZi";
    src: url("../../assets/fonts/YeJinShuZi.woff2");
}

.cB {
    width: 435px;
    height: 240px;

    padding: 10px 0;
}

.outer {
    width: 435px;
    height: 240px;
    position: relative;

    z-index: 1;
}

.main {
    width: 360px;
    height: 60px;
    line-height: 60px;
    margin: 0 auto;
    background: url('../../assets/template3/title-text-bg.png') no-repeat;
    background-size: 100% 100%;
    margin-bottom: 20px;

}

.m-item {
    position: relative;

    // padding: 12px 0 0 10px;
    .title {

        font-family: Source Han Sans CN;
        // font-weight: 400;
        font-size: 14px;
        padding-left: 4px;        color: #e3e4e6;
        margin-bottom: 6px;
        position: relative;

    }

    .title::after {
        content: "";
        width: 12px;
        height: 12px;
        background: url('../../assets/template3/fangkuai.png') no-repeat;
        background-size: 100% 100%;
        position: absolute;
        left: -20px;
        top: 24px;
       

    }

    .num {

        font-family: Source Han Sans CN;
        font-weight: 500;
        font-size: 16px;
        color: #FFFFFF;
        margin: 0 4px 0 0;
        position: absolute;
        right: 30px;
        top: 0;

    }

    .unit {
        width: 24px;
        height: 11px;
        // font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 12px;
        color: #CBCBCB;
        position: absolute;
        right: 0;
        top: 0;
    }
}
</style>